<template>
  <base-dialog :isOpen="dialogOpen" @closeDialog="toggleDialog">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('app.new_document')}}</h2>
          <base-tooltip-icon size="sm" :content="extensionTooltipMessage" class="ml-2"/>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4">
        <el-form
          :model="form"
          :rules="newRules"
          ref="ruleForm"
        >
        <div 
          class="px-2 mb-2 lg:mb-0 "
          :class="[isLower1024 ? '' : 'center']">
          <el-form-item prop="file" ref="fileRef">
            <Upload
                ref="upload"
                id="fileSelector"
                class="bg-white dark:bg-darkblue-900 dark:bg-darkblue "
                :class="[isLower1024 ? 'custom-upload-cert' : 'custom-upload ']"
                drag
                multiple
                action="#"
                :auto-upload=false
                :on-progress="handleProgress"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :limit="maxFiles"
                :on-change="handleChange"
                :on-exceed="handleOnExceed"
                >
                <i class="el-icon-upload"></i>
                <p v-if="file.length" class="el-upload__text"><em>{{fileName}}</em></p>
                <div v-else class="el-upload__text" v-safe-html="$tc('app.upload_default_no_file_text', maxFiles)"></div>
            </Upload>
          </el-form-item>
        </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button :disabled="disabledApply" mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="uploadNewDocument('ruleForm')"/>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from './base/BaseDialog.vue'
import { Upload } from 'element-ui'
import { subirDocRel } from '@/services/invoices/subirDocRel'
import { i18n } from '@/i18n'
import { EXTENSIONES_ADJUNTOS } from '@/config/extensiones-adjuntos'

export default
{
  name: 'invoice-new-document-dialog',
  components: {
    BaseDialog,
    Upload
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    idFacturae: {
      type: Number,
      default: -1
    },
    idInvoice: {
      type: Number,
      default: -1
    }
  },
  data: function () {
    return {
      isOpen: this.dialogOpen,
      form: {
      },
      maxFiles: 8,
      maxSizeFile: 5242880, // Bytes (5MB)
      extensionesAdjuntosPermitidas: EXTENSIONES_ADJUNTOS,
      file: [],
      newRules: {
        file: [
          {
            required: true,
            message: i18n.t('validation.exceed_size_files') + ' (5 MB)',
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              if (!this.file || this.file.filter(x => x.size > this.maxSizeFile).length > 0) {
                callback(new Error(i18n.t('validation.exceed_size_files') + ' (5 MB)'))
              } else {
                callback()
              }
            }
          },
          {
            required: true,
            message: this.extensionRuleMessage,
            trigger: ['blur', 'change'],
            validator: (rule, value, callback) => {
              let invalidExtension = false
              this.file.forEach(archivo => {
                if (!this.extensionesAdjuntosPermitidas.includes(this.getExtensionFromFileName(archivo.name).toUpperCase())) {
                  invalidExtension = true
                }
              })
              if (invalidExtension) {
                callback(new Error(this.extensionRuleMessage))
              } else {
                callback()
              }
            }
          },
        ]
      }
    }
  },
  mounted: async function () {
  },
  computed: {
    extensionRuleMessage: function () {
      return i18n.t('validation.not_extension', { exts: this.extensionesAdjuntosPermitidas.join(', ') })
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    fileName () {
      if (this.file === null || this.file.length === 0) {
        return ''
      } else if (this.file.length === 1) {
        return this.file[0].name
      } else {
        return i18n.tc('app.n_files', this.file.length)
      }
    },
    disabledApply: function () {
      return this.file === undefined || this.file === null || this.file.length === 0
    },
    extensionTooltipMessage: function () {
      return i18n.t('validation.max_files', { maxFilesAdj: this.maxFiles }) + i18n.t('validation.max_size_files', { maxMBAdj: this.maxMB }) +
      i18n.t('validation.extension', { exts: this.extensionesAdjuntosPermitidas.join(', ') })
    },
    maxMB () {
      return this.maxSizeFile / 1024 / 1024
    },
  },
  methods: {
    getExtensionFromFileName (fileName) {
      return fileName.split('.').at(-1)
    },
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.file = []
      this.$emit('toggleDialog')
    },
    handleOnExceed: function () {
      this.doFeedback(i18n.t('validation.max_files_warn', { limit: this.maxFiles }), 'warning')
    },
    handleChange: function (file) {
      this.$refs.fileRef.clearValidate()
      this.file.push(file)
    },
    handleRemove: function (file) {
      this.file = this.file.filter(x => x.uid !== file.uid)
    },
    handlePreview: function () {
    },
    handleProgress: function (e) {
    },
    uploadNewDocument: async function (formName) {
      this.$refs[formName].validate(async (valid) => {
        try {
          if (valid) {
            const params = {
              idFacturae: this.idFacturae,
              idInvoice: this.idInvoice,
            }
            const response = await subirDocRel(this.file, params)
            if (response.blnError === true) {
              this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
            } else {
              this.$emit('applyDialog')
              this.doFeedback(i18n.t('feedback.success.added_documents_msg'), 'success')
              this.toggleDialog()
            }
          } else {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
          }
        } catch (error) {
          const mensajeError = error?.response?.statusText
          if (mensajeError) {
            this.doFeedback(mensajeError)
          } else {
            this.doFeedback()
          }
        } finally {
          // this.toggleDialog()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.center {
  margin: auto;
  width: 60%;
  border: none;
  padding: 1px;
}

</style>
